
$(function () {
    $('.header__slider').slick({
        infinite: true,
        fade: true,
        nextArrow: '<img class="arrow-right arrow-right-pos" src="img/arrow-right.svg" alt="arrow-right">',
        prevArrow: ' <img class="arrow-left arrow-left-pos" src="img/arrow-left.svg" alt="arrow-right">',
        asNavFor: '.header__slider__pag'
    });

    $('.header__slider__pag').slick({
        slidesToShow: 4,
        infinite: false,
        slidesToScroll: 4,
        cssEase: 'linear',
        asNavFor: '.header__slider',
        responsive: [
            {
                breakpoint: 785,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    focusOnSelect: true,
                }
            }
        ]
    });

    $('.slider__map').slick({
        slidesToShow: 8,
        slidesToScroll: 8,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: '.surf__slider',
        responsive: [
            {
                breakpoint: 1024,
                //settings: 'unslick'
            },
        ]

    });
    $('.slider__map__mobile').slick({
        slidesToShow: 3,
        slidesToScroll: 8,
        arrows: false,
        focusOnSelect: true,

        centerMode: true,
        asNavFor: '.surf__slider',
        responsive: [
            {
                breakpoint: 987,
                settings: {
                    slidesToShow: 1,
                }

            },
            {
                breakpoint: 715,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 401,
                settings: {
                    slidesToShow: 1,
                }
            }

        ]
    })

    $('.surf__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 8,
        focusOnSelect: true,
        centerMode: true,
        variableWidth: true,
        nextArrow: '<img class="arrow-right" src="img/arrow-right.svg" alt="arrow-right">',
        prevArrow: ' <img class="arrow-left" src="img/arrow-left.svg" alt="arrow-right">',
        asNavFor: '.slider__map',
        responsive: [
            {
                breakpoint: 1424,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 8,
                    //centerMode: true,
                    asNavFor: '.slider__map'
                }
            },
            {
                breakpoint: 1154,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 8,
                    asNavFor: '.slider__map'
                }
            },
            {
                breakpoint: 987,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    asNavFor: '.slider__map__mobile'
                }

            },
            {
                breakpoint: 712,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: '.slider__map__mobile'
                }

            },
            {
                breakpoint: 565,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: '.slider__map__mobile'
                }

            },
        ]
    });

    $('.travel__slider').slick({
        infinite: true,
        fade: true,
        nextArrow: '<img class="arrow-right" src="img/arrow-right.svg" alt="arrow-right">',
        prevArrow: ' <img class="arrow-left" src="img/arrow-left.svg" alt="arrow-right">',
    });
    $('.sleep__slider').slick({
        infinite: true,
        fade: true,
        nextArrow: '<img class="arrow-right" src="img/arrow-right.svg" alt="arrow-right">',
        prevArrow: ' <img class="arrow-left" src="img/arrow-left.svg" alt="arrow-right">',
    });
    $('.shop__slider').slick({
        infinite: true,
        nextArrow: '<img class="arrow-right" src="img/arrow-right.svg" alt="arrow-right">',
        prevArrow: ' <img class="arrow-left" src="img/arrow-left.svg" alt="arrow-right">',
    });

    $('.header-aside__search-img').on('click', function () {

        $('.header-aside__search-input').toggleClass('show');
    });


    $('.product__photo__dots').on('click', function () {
        $(this).toggleClass('active');

    });

    $('.menu__btn').on('click', function () {
        $('.header__nav__block').toggleClass('nav__active');
    });

    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.quantity input');
    $('.quantity').each(function () {
        var spinner = $(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');

        btnUp.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

        btnDown.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });

    });

    $('.quantity-button').on('click', function () {
        let summ = $('.night').val() * $('.summ').data('night') + ($('.guests').val() - 1) * $('.summ').data('guests');
        $('.summ').html('$ ' + summ + " ");
    });

    let btn = $('.button-top');

    $(window).scroll(function () {
        if ($(window).scrollTop() > 500) {
            btn.addClass('show');
        } else {
            btn.removeClass('show');
        }
    });

    btn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '300');
    });

    anchors();
    showDate();

    let wow = new WOW(
        {
        mobile: false
        }
    )
    wow.init();
});



function anchors() {
    let anchors = $('a[href^="#"]');
    anchors.on('click', function (e) {
        let target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top + 150
        }, 500);
    });
}

function showDate() {
    let dateDay = $('.header-aside__date__day');
    let newDateDay = new Date();
    dateDay.html(newDateDay.getDate());

    let dateMonthYear = $('.header-aside__date__monthyear');
    let mm = newDateDay.getMonth() + 1;
    if ((mm < 10)) {
        dateMonthYear.html(mm = '0' + mm + " | " + newDateDay.getUTCFullYear());
    }
}




